import styled from 'styled-components';
import { Stack } from '@karma/components';

export const EmptyStateTitlesContainer = styled(Stack)`
  max-width: 520px;
  text-align: center;
`;
